/**
 * @class Walk
 *
 * @method constructor
 *     @param {HTMLElement} el
 *
 * @method walk
 * @method stop
 *
 * Create a walk cycle for the pamplemousse
 */

const selectors = {
  step: '.js-pamplemousse-step',
};

const classes = {
  active: 'is-active',
};

export default class Walk {
  constructor(el) {
    this.el = el;
    this.steps = this.el.querySelectorAll(selectors.step);

    this.i = 0;
    this.stepInterval = 200;
    this.walkSpeed = 0.3;
    this.stepTimeout;
    this.velocity = 200;

    this.isWalking = false;
  }

  updateVelocity(velocity) {
    this.velocity = velocity;
  }

  updateActiveStep() {
    this.steps.forEach((step, idx) => {
      if (idx === this.i) {
        step.classList.add(classes.active);
      } else {
        step.classList.remove(classes.active);
      }
    });
  }

  walkCycle() {
    if (this.i >= this.steps.length - 1) {
      this.i = 3;
    } else {
      this.i++;
    }
    this.updateActiveStep();
    if (!this.isWalking) return;
    this.stepTimeout = setTimeout(
      this.walkCycle.bind(this),
      this.stepInterval - this.velocity * this.walkSpeed,
    );
  }

  walk() {
    this.i = 0;
    clearTimeout(this.stepTimeout);
    for (let j = 0; j < 3; j++) {
      this.stepTimeout = setTimeout(
        () => {
          this.updateActiveStep();
          this.i++;
        },
        (this.stepInterval - this.velocity * this.walkSpeed) * j,
      );
    }
    this.isWalking = true;
    this.walkCycle();
  }

  stop() {
    this.isWalking = false;
    clearTimeout(this.stepTimeout);
    this.i = 0;
    this.updateActiveStep();
  }

  destroy() {
    clearTimeout(this.stepTimeout);
    this.steps.forEach(step => {
      step.classList.remove(classes.active);
    });
  }
}
